import { Component, computed, input, linkedSignal } from '@angular/core';

import { ResolvableModal, UiCoreModule } from '@softline/ui-core';
import { FilterListComponent } from '../../components/filter-list/filter-list.component';
import { SortFormComponent } from '../../components/sort-form/sort-form.component';
import { FilterConfig } from '../../types/filter-config';
import { filter, Filter, ObjectSort } from '@softline/core';
import { SortConfig } from '../../types/sort-config';

export type FilterAndSort = {filter: Filter[] | null | undefined, sort: ObjectSort<any> | null | undefined};

@Component({
    selector: 'soft-filter-and-sort-dialog',
    imports: [UiCoreModule, FilterListComponent, SortFormComponent],
    templateUrl: './filter-and-sort.dialog.html',
    styleUrls: ['./filter-and-sort.dialog.css']
})
export class FilterAndSortDialog extends ResolvableModal<FilterAndSort> {
  readonly filterConfig = input<FilterConfig | null | undefined>();
  readonly sortConfig = input<SortConfig | null | undefined>();
  readonly items = input<object[] | null | undefined>([]);
  readonly filters = input<Filter[] | null | undefined>();
  readonly sort = input<ObjectSort<object> | null | undefined>();

  count = computed(() => {
    return filter(this.items() ?? [], this.filters());
  })

  readonly currentFilters = linkedSignal<Filter[] | null | undefined>(() => this.filters());
  readonly currentSort = linkedSignal(() => this.sort());

  onSubmit(): void {
    this.resolve({
      filter: this.currentFilters(),
      sort: this.currentSort(),
    })
  }
}
